// import React from 'react';
// import './styles.css';


// const About = ({ aboutText }) => {
//     return (
//         <section id="about">
//             <h2>About Me</h2>
//             <p>{aboutText}</p>
//         </section>
//     );
// };

// export default About;
import React from 'react';
import './About.css';
import '../App.css';
// import { useHistory } from 'react-router-dom';
import { useNavigate } from 'react-router-dom'
import Projects from './Projects';
import Footer from './Footer'
import { Link } from 'react-router-dom';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';

const About = ({ aboutText }) => {
    // const navigate = useNavigate();

    // function redirectToProjectsPage() {
    //     navigate('/projects', { replace: true });
    // }
    return (
        <div class="homepagedark">
      <div class="bg1">
        <div class="bg-item"></div>
        <div class="line-group">
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
          <div class="frame-child5"></div>
        </div>
      </div>
      <div class="ololade-group">
        <div class="ololade2">
          <span>SIYA GAMPAWAR</span>
          <span class="span2">.</span>
        </div>
        <div class="download-btndark">
          <div class="download-btndark-child"></div>
          <div class="download-btndark-item"></div>
          <div class="resume1">Resume</div>
          <img
            class="akar-iconsdownload1"
            alt=""
            src="akariconsdownload.svg"
          />
        </div>
      </div>
      <b class="hello-my-name-container1">
        <p class="hello1">About Me</p>
        <br></br>
        {/* <p style={{ fontSize: '25px', lineHeight: '35px', wordWrap: 'break-word' ,color:'#2e7dd7'}}>hieejgnekdszgbbbbbbbbbbbbbbb</p>
        <p style={{ fontSize: '25px', lineHeight: '35px', wordWrap: 'break-word' ,color:'#2e7dd7'}}>hieejgnekdszgbbbbbbbbbbbbbbb</p>
        <p style={{ fontSize: '25px', lineHeight: '35px', wordWrap: 'break-word' ,color:'#2e7dd7'}}>hieejgnekdszgbbbbbbbbbbbbbbb</p>
        <p style={{ fontSize: '25px', lineHeight: '35px', wordWrap: 'break-word' ,color:'#2e7dd7'}}>hieejgnekdszgbbbbbbbbbbbbbbb</p>
 */}

   
      </b>
      <div class="i-like-to2" style={{color:'#2e7dd7'}}>
      I am an aspiring Data Science Engineer with expertise in MERN stack, Go, C, and Java. Skilled in using Power BI and Tableau for data visualization. I have experience in full-stack development and creating RESTful APIs. Passionate about data analysis, predictive modeling, and transforming complex data into actionable insights. Committed to continuous learning and innovation in data science.







      </div>
      {/* <div class="button1">
        <div class="button-item"></div>
        <div class="say-hello-container">
          <div class="say-hello1">Say Hello</div>
        </div>
      </div> */}
      <div class="bottm-bar1">
        <div class="frame-group">
        {/* <div class="profile-wrapper"> */}
        <Link to="/">
          <div class="home-container">
            <img class="bimoon-fill-icon" alt="" src="home.svg" />
          </div>
          {/* </div> */}
          </Link>
          
          <img class="frame-child11" alt="" src="frame-5.svg" />
          <Link to="/About">
          <div class="profile-wrapper">
            <img class="bimoon-fill-icon" alt="" src="profile.svg" />
          </div></Link>
          
          <div class="home-container">
          {/* <Link to="/footer"> */}
            <img
              class="bimoon-fill-icon"
              alt=""
              src="iconlybulklightbulb.svg"
            />
            {/* </Link> */}
          </div>
          {/* <Router>
          <Routes>
               <Route path='/footer' Component={Footer} />
          </Routes>
          </Router> */}
          <div class="frame-child12"></div>
          <div class="home-container">
            <img class="bimoon-fill-icon" alt="" src="message.svg" />
          </div>
          <div class="home-container">
            <img class="bimoon-fill-icon" alt="" src="calendar.svg" />
          </div>
          <div class="home-container">
            <img
              class="bimoon-fill-icon"
              alt=""
              src="akariconstwitterfill.svg"
            />
          </div>
          <div class="home-container">
            <img
              class="bimoon-fill-icon"
              alt=""
              src="antdesignbehanceoutlined.svg"
            />
          </div>
          <div class="home-container">
            <img
              class="bimoon-fill-icon"
              alt=""
              src="antdesigndribbbleoutlined.svg"
            />
          </div>
          <div class="figma1">
            <img
              class="bimoon-fill-icon"
              alt=""
              src="phfigmalogoduotone.svg"
            />
          </div>
          <div class="frame-child12"></div>
          <div class="home-container">
            <img
              class="bimoon-fill-icon"
              alt=""
              src="bimoonfill.svg"
            />
          </div>
        </div>
      </div>
    </div>
    );
};
export default About;